<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0"><WarningRequiredFields /></div>
    <div class="col-md-12 pt-0 pb-0">
      <label v-if="data.type == 'CONTAS_A_PAGAR'">É um gasto</label>
      <label v-if="data.type == 'CONTAS_A_RECEBER'">É um gasto</label>
      <div>
        <div class="form-check form-check-inline">
          <input
            @input="handleInputType"
            v-model="type"
            class="form-check-input"
            type="radio"
            name="type"
            id="paid"
            value="paid"
          />
          <label
            v-if="data.type == 'CONTAS_A_PAGAR'"
            class="form-check-label"
            for="paid"
            >pago</label
          >
          <label
            v-if="data.type == 'CONTAS_A_RECEBER'"
            class="form-check-label"
            for="paid"
            >recebido</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input
            @input="handleInputType"
            v-model="type"
            class="form-check-input"
            type="radio"
            name="type"
            id="not_paid"
            value="not_paid"
          />
          <label
            v-if="data.type == 'CONTAS_A_PAGAR'"
            class="form-check-label"
            for="not_paid"
            >a pagar</label
          >
          <label
            v-if="data.type == 'CONTAS_A_RECEBER'"
            class="form-check-label"
            for="not_paid"
            >a receber</label
          >
        </div>
      </div>
    </div>
    <div class="col-md-3 pt-0 pb-0 input-form-required">
      <label>Vence em</label>
      <input
        type="date"
        class="form-control form-control-sm"
        v-model="due_date"
      />
    </div>
    <div class="col-md-3 pt-0 pb-0 input-form-required">
      <label v-if="is_paid && data.type == 'CONTAS_A_PAGAR'">Paga em</label>
      <label v-if="is_paid && data.type == 'CONTAS_A_RECEBER'"
        >Recebida em</label
      >
      <input
        v-if="is_paid"
        type="date"
        class="form-control form-control-sm"
        v-model="paid_in_date"
      />
      <div class="form-check" v-if="type == 'not_paid'">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="is_paid"
          id="is_paid"
        />
        <label
          v-if="data.type == 'CONTAS_A_PAGAR'"
          class="form-check-label"
          for="is_paid"
        >
          Foi paga?
        </label>
        <label
          v-if="data.type == 'CONTAS_A_RECEBER'"
          class="form-check-label"
          for="is_paid"
        >
          Foi recebida?
        </label>
      </div>
    </div>
    <div class="col-md-6 pt-0 pb-0 input-form-required">
      <LabelRequiredField label="Na conta" />
      <select
        class="form-control form-control-sm"
        v-model="finance_configuration_account_id"
      >
        <option
          v-for="account in finance_configuration_account"
          :key="account.id"
          :value="account.id"
        >
          {{ account.account_nickname }}
        </option>
      </select>
    </div>
    <div class="col-md-12 pt-0 pb-0"><hr /></div>
    <div
      v-if="['NAO_SE_REPETE', 'MAIS_DE_UMA_VEZ', 'SEMPRE'].includes(repeat)"
      class="col-md-6 pt-0 pb-0"
    >
      <label>Repetir</label>
      <div class="d-flex">
        <v-btn
          small
          :class="[repeat == 'NAO_SE_REPETE' && 'v-dark']"
          @click="handleClickRepeat('NAO_SE_REPETE')"
          ><i class="fas fa-file mr-2"></i>NÃO SE REPETE</v-btn
        >
        <v-btn
          small
          :class="[repeat == 'MAIS_DE_UMA_VEZ' && 'v-dark']"
          @click="handleClickRepeat('MAIS_DE_UMA_VEZ')"
          ><i class="fas fa-copy mr-2"></i>MAIS DE UMA VEZ</v-btn
        >
        <v-btn
          small
          :class="[repeat == 'SEMPRE' && 'v-dark']"
          @click="handleClickRepeat('SEMPRE')"
          ><i class="fas fa-sync mr-2"></i>SEMPRE</v-btn
        >
      </div>
    </div>
    <div
      v-if="repeat == 'MAIS_DE_UMA_VEZ' || repeat == 'SEMPRE'"
      class="col-md-3 pt-0 pb-0 input-form-required"
    >
      <label>Periodicidade</label>
      <select class="form-control form-control-sm" v-model="periodicity">
        <option value="">SELECONE...</option>
        <option value="SEMANAL">SEMANAL</option>
        <option value="QUINZENAL">QUINZENAL</option>
        <option value="MENSAL">MENSAL</option>
        <option value="BIMESTRAL">BIMESTRAL</option>
        <option value="TRIMESTRAL">TRIMESTRAL</option>
        <option value="SEMESTRAL">SEMESTRAL</option>
        <option value="ANUAL">ANUAL</option>
      </select>
    </div>
    <div
      v-if="repeat == 'MAIS_DE_UMA_VEZ'"
      class="col-md-3 pt-0 pb-0 input-form-required"
    >
      <label>QUANTAS VEZES</label>
      <div class="input-group">
        <div
          class="
            input-group-pprend
            d-flex
            align-items-center
            justify-content-center
            pl-2
            pr-2
            border
          "
        >
          Por
        </div>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="how_many_times"
        />
        <div
          class="
            input-group-pprend
            d-flex
            align-items-center
            justify-content-center
            pl-2
            pr-2
            border
          "
        >
          vezes
        </div>
      </div>
    </div>
    <div class="col-md-12 pt-0 pb-0"><hr /></div>
    <div class="col-md-12 pt-0 pb-0">
      <div class="row" v-for="(item, key) in items" :key="key">
        <div class="col-md-11 pt-0 pb-0">
          <div class="row">
            <div class="col-md-6 input-form-required">
              <input
                placeholder="Descrição"
                type="text"
                v-model="item.description"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-2 input-form-required">
              <select
                v-model="item.spent_or_gain"
                class="form-control form-control-sm"
                @change="handleSpentOrGainItem(key)"
              >
                <option value="DEBITO">DÉBITO</option>
                <option value="CREDITO">CRÉDITO</option>
              </select>
            </div>
            <div class="col-md-4 input-form-required">
              <input
                placeholder="Valor"
                type="text"
                @input="handleInputValue($event.target.value, key)"
                v-model="item.value"
                :class="[
                  'form-control form-control-sm',
                  item.spent_or_gain == 'DEBITO' && 'c-danger',
                  item.spent_or_gain == 'CREDITO' && 'c-success',
                ]"
              />
            </div>
            <div class="col-md-3 vue-treeselect-required">
              <treeselect
                :options="finance_configuration_category"
                placeholder="SELECIONE..."
                v-model="item.finance_configuration_category_id"
                noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
              />
            </div>
            <div class="col-md-3">
              <select
                v-model="item.finance_configuration_profit_cost_center_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Centro de custo/lucro...</option>
                <option
                  v-for="profit_cost_center in finance_configuration_profit_cost_center"
                  :key="profit_cost_center.id"
                  :value="profit_cost_center.id"
                >
                  {{ profit_cost_center.description }}
                </option>
              </select>
            </div>
            <div class="col-md-3" v-if="item.spent_or_gain == 'DEBITO'">
              <select
                v-model="item.provider_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Fornecedor...</option>
                <option
                  v-for="provider in providers"
                  :key="provider.id"
                  :value="provider.id"
                >
                  {{ provider.company_name }}
                </option>
              </select>
            </div>
            <div class="col-md-3" v-if="item.spent_or_gain == 'CREDITO'">
              <select
                v-model="item.finance_client_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Cliente...</option>
                <option
                  v-for="client in finance_client"
                  :key="client.id"
                  :value="client.id"
                >
                  {{ client.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                v-model="item.finance_configuration_payment_methods_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Forma de pagamento...</option>
                <option
                  v-for="payment_method in finance_configuration_payment_methods"
                  :key="payment_method.id"
                  :value="payment_method.id"
                >
                  {{ payment_method.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <vs-select
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  pt-0
                  pb-0
                  pl-0
                  pr-0
                "
                placeholder="Tags..."
                multiple
                autocomplete
                v-model="item.finance_configuration_tag_ids"
              >
                <vs-select-item
                  v-for="tag in finance_configuration_tag"
                  :key="tag.id"
                  :text="tag.description"
                  :value="tag.id"
                />
              </vs-select>
            </div>
            <div class="col-md-3">
              <select
                v-model="item.cost_type"
                class="form-control form-control-sm"
              >
                <option :value="null">Tipo de custo...</option>
                <option
                  v-for="type in cost_types"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.description }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                v-model="item.cost_appropriation"
                class="form-control form-control-sm"
              >
                <option :value="null">Apropriação de custo...</option>
                <option
                  v-for="appropriation in cost_appropriations"
                  :key="appropriation.value"
                  :value="appropriation.value"
                >
                  {{ appropriation.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="
            col-md-1
            d-flex
            align-items-center
            justify-content-center
            pt-0
            pb-0
          "
        >
          <ConfirmationDialog
            v-if="items.length > 1"
            small
            headerClass="modal-header-i"
            message-title="REMOVER?"
            :message-body="`Deseja realmente remover o item?`"
            open-class="btn-delete"
            open-left-icon="fa-times"
            @yes="handleRemoveItem(key)"
          />
        </div>
        <div class="col-md-12 pt-0 pb-0"><hr /></div>
      </div>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <v-btn small class="v-primary" @click="handleAddItem"
        ><i class="fas fa-plus mr-2"></i> ADICIONAR OUTRO ITEM</v-btn
      >
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <hr />
      <div class="row">
        <div class="col-md-6 pt-0 pb-0">
          <label>Observação</label>
          <ChromeSpeechToTextTextarea rows="3" v-model="note" />
        </div>
        <div class="col-md-6 pt-0 pb-0">
          <div class="row">
            <div class="col-md-12 pt-0 pb-0">
              <label>Competência</label>
              <input
                type="date"
                class="form-control form-control-sm"
                v-model="competence"
              />
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label>Tipo de documento</label>
              <select
                class="form-control form-control-sm"
                v-model="finance_configuration_document_types_id"
              >
                <option
                  v-for="document_type in finance_configuration_document_types"
                  :key="document_type.id"
                  :value="document_type.id"
                >
                  {{ document_type.description }}
                </option>
              </select>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <label>Número do documento</label>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="document_number"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-6 pb-0">
      <v-btn class="btn-cancel mr-2" @click="handleCancel"
        ><i class="fas fa-times mr-2"></i>CANCELAR
      </v-btn>
    </div>
    <div class="col-md-6 pb-0 text-right">
      <v-btn :disabled="loading" @click="create" class="btn-save"
        ><i class="fas fa-check mr-2"></i
        >{{ loading ? "CARREGANDO" : "SALVAR" }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../Components/ErrorsMessages";

import ConfirmationDialog from "../../../../Components/ConfirmationDialog";

import ChromeSpeechToTextTextarea from "../../../../Components/ChromeSpeechToTextTextarea";

import LabelRequiredField from "../../../../Components/LabelRequiredField";

import WarningRequiredFields from "../../../../Components/WarningRequiredFields";

import Treeselect from "@riophae/vue-treeselect";

import {
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../../../lib/format";

import api from "../../../../../services/api";

import toast from "../../../../../lib/ToastNotification";
import moment from "moment";

export default {
  name: "Duplicate",
  components: {
    ErrorsMessages,
    ConfirmationDialog,
    ChromeSpeechToTextTextarea,
    LabelRequiredField,
    WarningRequiredFields,
    Treeselect,
  },
  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },
  data() {
    return {
      finance_configuration_account_id: "",
      due_date: "",
      finance_configuration_document_types_id: "",
      how_many_times: "",
      document_number: "",
      competence: "",
      note: "",
      paid_in_date: "",
      periodicity: "",
      repeat: "NAO_SE_REPETE",
      is_paid: false,
      type: false,
      items: [],
      errors: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,
    handleInputType(event) {
      let { value } = event.target;

      if (value == "paid") {
        this.is_paid = true;
      } else {
        this.is_paid = false;
      }

      this.repeat = "NAO_SE_REPETE";
    },
    handleClickRepeat(repeat) {
      this.repeat = repeat;
    },
    handleInputValue(value, key) {
      if (this.items[key].spent_or_gain == "DEBITO") {
        this.items[key].value = formatValueNegativeOnKeyUp(value);
      } else {
        this.items[key].value = formatValueOnKeyUp(value);
      }
    },
    handleSpentOrGainItem(key) {
      this.items[key].provider_id = "";
      this.items[key].finance_client_id = "";
      this.handleInputValue(this.items[key].value, key);
    },
    handleAddItem() {
      let { items } = this;

      let lastItem = items[items.length - 1];

      let {
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_client_id,
        finance_configuration_payment_methods_id,
        finance_configuration_tag_ids,
        cost_type,
        cost_appropriation,
        spent_or_gain,
      } = lastItem;

      let item = {
        id: false,
        description: "",
        value: "",
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_client_id,
        finance_configuration_payment_methods_id,
        finance_configuration_tag_ids,
        cost_type,
        cost_appropriation,
        spent_or_gain,
      };

      this.items = [...items, item];
    },
    handleRemoveItem(key) {
      this.items.splice(key, 1);
    },
    retrieve() {
      let { data } = this;

      this.finance_configuration_account_id =
        data.finance_configuration_account_id;
      this.due_date = data.due_date
        ? moment(data.due_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      this.finance_configuration_document_types_id =
        data.finance_configuration_document_types_id;
      this.how_many_times = data.how_many_times;
      this.document_number = data.document_number;
      this.competence = data.competence
        ? moment(data.competence).format("YYYY-MM-DD")
        : "";
      this.paid_in_date = data.paid_in_date
        ? moment(data.paid_in_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      this.periodicity = data.periodicity;
      this.note = data.note ? data.note : "";
      this.is_paid = data.is_paid == 1 ? true : false;
      this.repeat = data.is_repeat ? data.is_repeat : "";
      this.type = data.is_paid == 1 ? "paid" : "not_paid";

      for (let item of data.items) {
        if (item.spent_or_gain == "DEBITO") {
          item.value = formatValueNegativeOnKeyUp(item.value);
        } else {
          item.value = formatValueOnKeyUp(item.value);
        }

        this.items.push({
          id: item.id,
          description: item.description,
          value: item.value,
          finance_configuration_category_id:
            item.finance_configuration_category_id,
          finance_configuration_profit_cost_center_id:
            item.finance_configuration_profit_cost_center_id,
          provider_id: item.provider_id,
          finance_client_id: item.finance_client_id,
          finance_configuration_payment_methods_id:
            item.finance_configuration_payment_methods_id,
          finance_configuration_tag_ids: item.finance_configuration_tag_ids,
          cost_type: item.cost_type,
          cost_appropriation: item.cost_appropriation,
          spent_or_gain: item.spent_or_gain,
        });
      }
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async create() {
      try {
        this.loading = true;

        const {
          data,
          type,
          finance_configuration_account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
        } = this;

        let params = {
          type,
          account_id: finance_configuration_account_id,
          repeat,
          is_paid,
          due_date,
          paid_in_date,
          periodicity,
          how_many_times,
          items,
          note,
          competence,
          finance_configuration_document_types_id,
          document_number,
          finance_launch_bills_to_pay_type: data.type,
        };

        const response = await api.post(
          "/rest-home/financial/launch/pay",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("success");

          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>